import type { Invoice } from "@nlc/shared-types";

import { DownloadIcon, EyeIcon, LinkIcon } from "lucide-react";

import { Button } from "@/components/button";

interface InvoiceActionButtonsProps {
  invoice: Invoice;
  onCopyLink: (invoice: Invoice) => void;
}

export function InvoiceActionButtons({
  invoice,
  onCopyLink,
}: InvoiceActionButtonsProps) {
  return (
    <div className="grid grid-cols-2 gap-x-md gap-y-lg">
      <Button className="w-full" size="sm" variant="secondary">
        <EyeIcon size={16} />
        View invoice
      </Button>

      <Button
        className="w-full"
        onPress={() => onCopyLink(invoice)}
        size="sm"
        variant="secondary"
      >
        <LinkIcon size={16} />
        Copy link
      </Button>

      <Button className="col-span-2 w-full" size="sm" variant="secondary">
        <DownloadIcon size={16} />
        Download
      </Button>
    </div>
  );
}
